import React from 'react'
import { motion } from "framer-motion";


function ViewWrapper({children}) {
  return (
    <motion.section 
      className="portfolio-intro"
      initial={{ opacity: 0, x: -500 }}
      animate={{ opacity: 0.94, x: 0 }}
      transition={{ duration: 0.7 }}
    >
        {children}
    </motion.section>
  )


}

export default ViewWrapper